import React from 'react';
import CaseForm from '../components/CaseForm';


const ActionEditPage = () => {
  return (<CaseForm />);
};

export default ActionEditPage;
